// in-view reference: https://jsfiddle.net/2tgLpfx5/
// Drupal implementation - core/underscore needs to be added to libraries.yml for _ variable

function throttle(func, timeFrame) {
  let lastTime = 0;
  return function (...args) {
    const now = new Date();
    if (now - lastTime >= timeFrame) {
      func(...args);
      lastTime = now;
    }
  };
}

// Find all inViewElements classes
const inViewElements = document.querySelectorAll('.in-view-element');

// Find the dimensions of inViewport
// Only the vertical position is checked: decorative elements like the
// concentric circles intentionally overhang the viewport horizontally, so a
// left/right bounds check would keep them hidden on narrow screens.
const inViewport = function (e) {
  const distance = e.getBoundingClientRect();
  return (
    distance.top <= (window.innerHeight - 200 || document.documentElement.clientHeight - 200)
  );
};

// Set inView
function isInView() {
  for (let i = 0; i < inViewElements.length; i++) {
    // For each inViewElements
    if (inViewport(inViewElements[i])) {
      // If in view
      inViewElements[i].classList.add('in-view');
    }
  }
}

// If has inViewElements, run throttled inViewport
if (inViewElements) {
  // Throttle scroll behavior
  isInView();
  window.addEventListener('scroll', throttle(isInView, 50));
}
